import { Box, Button, CircularProgress, Typography } from "@mui/material";
import ArrowBackRounded from "@mui/icons-material/ArrowBackRounded";
import ArrowForwardRounded from "@mui/icons-material/ArrowForwardRounded";
export default function FlowActions({
  onBack,
  onContinue,
  backLabel = "Voltar",
  continueLabel = "Continuar",
  hint,
  disabled = false,
  busy = false,
}) {
  return (
    <Box
      className="flow-actions"
      sx={{
        position: "sticky",
        bottom: 12,
        zIndex: 20,
        mt: 3,
        p: { xs: 2, md: 2.5 },
        border: "1px solid #dce7df",
        borderRadius: 3,
        bgcolor: "rgba(255,255,255,.97)",
        backdropFilter: "blur(12px)",
        boxShadow: "0 8px 30px #173d2412",
        display: "grid",
        gridTemplateColumns: { xs: "1fr 1fr", sm: "auto minmax(0, 1fr) auto" },
        alignItems: "center",
        gap: 2,
        "& .MuiButton-root": { minHeight: 44, borderRadius: 2, px: 2.5, height: "100%" },
      }}
    >
      {onBack && (
        <Button
          sx={{ gridColumn: 1, gridRow: { xs: 2, sm: 1 } }}
          variant="outlined"
          onClick={onBack}
          disabled={busy}
          startIcon={<ArrowBackRounded />}
        >
          {backLabel}
        </Button>
      )}
      {hint && (
        <Typography
          variant="body2"
          sx={{ gridColumn: { xs: "1 / -1", sm: 2 }, gridRow: 1, color: "#52685b", fontSize: 13 }}
        >
          {hint}
        </Typography>
      )}
      <Button
        sx={{ gridColumn: { xs: onBack ? 2 : "1 / -1", sm: 3 }, gridRow: { xs: 2, sm: 1 } }}
        variant="contained"
        color="info"
        onClick={onContinue}
        disabled={disabled || busy}
        endIcon={busy ? <CircularProgress size={16} color="inherit" /> : <ArrowForwardRounded />}
      >
        {continueLabel}
      </Button>
    </Box>
  );
}
